module.exports = __webpack_public_path__ + "static/media/hair (1).3f82d332.jpg";